"use client";

import { Database, Cpu, Zap, Settings } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  icon: Database,
  title: "Reduced Manual Work",
  description: "We help remove repetitive tasks from daily workflows, allowing your team to spend less time on manual processing and more time on higher-value work.",
  metric: "Result: fewer repetitive steps"
}, {
  icon: Cpu,
  title: "Improved Accuracy",
  description: "Automation helps reduce avoidable errors caused by manual data entry, inconsistent spreadsheets, and repeated copy-paste processes.",
  metric: "Result: cleaner and more reliable outputs"
}, {
  icon: Zap,
  title: "Scalable Processes",
  description: "Our solutions are designed around your business workflow, making it easier to handle growing workloads without adding unnecessary complexity.",
  metric: "Result: processes that grow with your business"
}, {
  icon: Settings,
  title: "Better Operational Control",
  description: "Structured workflows, validation checks, and clear outputs help your business maintain stronger control over recurring tasks and reporting processes.",
  metric: "Result: clearer processes and better visibility"
}];
export default function Benefits() {
  const heading = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}